'use client';

import React from 'react';
import ErrorPageModule from '@/modules/error';
export default function Error() {
  return (
    <div className="bg-white h-full">
      <ErrorPageModule statusCode={404} />
    </div>
  );
}
